import * as React from "react";
import { type RouteProps } from "react-router";
import { DialogType } from "@onshopfront/components";
import DialogRoute from "../../Common/Dialogs/DialogRoute";
import { InjectRouteParams } from "../../Common/Routing/InjectRouteParams";
import { PermissionRoute } from "../../Common/Routing/PermissionRoute";

const Classifications = React.lazy(() => import("./Classifications"));
const ClassificationModifyDialog = React.lazy(() => import("./ClassificationModifyDialog"));
const BrandAssign = React.lazy(() => import("./Brands/BrandAssign"));
const CategoryAssign = React.lazy(() => import("./Categories/CategoryAssign"));
const FamilyAssign = React.lazy(() => import("./Families/FamilyAssign"));
const TagAssign = React.lazy(() => import("./Tags/TagAssign"));
const BrandView = React.lazy(() => import("./Brands/BrandView"));
const CategoryView = React.lazy(() => import("./Categories/CategoryView"));
const FamilyView = React.lazy(() => import("./Families/FamilyView"));
const TagView = React.lazy(() => import("./Tags/TagView"));

export default function ClassificationIndex(): Array<React.ReactElement<RouteProps>> {
    return [
        <PermissionRoute
            permissions={[ "see_classifications" ]}
            title="Classifications | Shopfront"
            path="/classifications"
            key="classifications"
            element={<Classifications />}
        >
            <PermissionRoute
                permissions={[ "edit_classifications" ]}
                path="brand/:id"
                key="brand-edit"
                element={
                    <DialogRoute
                        title="Modify Brand"
                        content={(
                            <ClassificationModifyDialog
                                type="Brand"
                            />
                        )}
                        type={DialogType.Edit}
                    />
                }
            />
            <PermissionRoute
                permissions={[ "edit_classifications" ]}
                path="category/:id"
                key="category-edit"
                element={
                    <DialogRoute
                        title="Modify Category"
                        content={(
                            <ClassificationModifyDialog
                                type="Category"
                            />
                        )}
                        type={DialogType.Edit}
                    />
                }
            />
            <PermissionRoute
                permissions={[ "edit_classifications" ]}
                path="family/:id"
                key="family-edit"
                element={
                    <DialogRoute
                        title="Modify Family"
                        content={(
                            <ClassificationModifyDialog
                                type="Family"
                            />
                        )}
                        type={DialogType.Edit}
                    />
                }
            />
            <PermissionRoute
                permissions={[ "edit_classifications" ]}
                path="tag/:id"
                key="tag-edit"
                element={
                    <DialogRoute
                        title="Modify Tag"
                        content={(
                            <ClassificationModifyDialog
                                type="Tag"
                            />
                        )}
                        type={DialogType.Edit}
                    />
                }
            />
        </PermissionRoute>,
        <PermissionRoute
            permissions={[ "see_classifications" ]}
            title="View Brand | Shopfront"
            path="/brand/:id"
            key="brand-view"
            element={<BrandView />}
        />,
        <PermissionRoute
            permissions={[ "see_classifications" ]}
            title="View Category | Shopfront"
            path="/category/:id"
            key="category-view"
            element={<CategoryView />}
        />,
        <PermissionRoute
            permissions={[ "see_classifications" ]}
            title="View Family | Shopfront"
            path="/family/:id"
            key="family-view"
            element={<FamilyView />}
        />,
        <PermissionRoute
            permissions={[ "see_classifications" ]}
            title="View Tag | Shopfront"
            path="/tag/:id"
            key="tag-view"
            element={<TagView />}
        />,
        <PermissionRoute
            permissions={[ "edit_products" ]}
            title="Edit Brand | Shopfront"
            path="/brand/:id/assign"
            key="brand-assign"
            element={<InjectRouteParams route={BrandAssign} />}
        />,
        <PermissionRoute
            permissions={[ "edit_products" ]}
            title="Edit Category | Shopfront"
            path="/category/:id/assign"
            key="category-assign"
            element={<InjectRouteParams route={CategoryAssign} />}
        />,
        <PermissionRoute
            permissions={[ "edit_products" ]}
            title="Edit Family | Shopfront"
            path="/family/:id/assign"
            key="family-assign"
            element={<InjectRouteParams route={FamilyAssign} />}
        />,
        <PermissionRoute
            permissions={[ "edit_products" ]}
            title="Edit Tag | Shopfront"
            path="/tag/:id/assign"
            key="tag-assign"
            element={<InjectRouteParams route={TagAssign} />}
        />,
    ];
}
